import API from '@/services/api'

// Actions
export const FETCH_DAMAGES = 'fetchDamages'
export const FETCH_ALL_DAMAGES = 'fetchAllDamages'
export const FETCH_DAMAGE = 'fetchDamage'
export const CREATE_DAMAGE = 'createDamage'
export const UPDATE_DAMAGE = 'updateDamage'
export const DELETE_DAMAGE = 'deleteDamage'

// Mutations
export const STORE_SET_DAMAGES = 'storeSetDamages'
export const STORE_ADD_DAMAGE = 'storeAddDamage'
export const STORE_UPDATE_DAMAGE = 'storeUpdateDamage'
export const STORE_ADD_REVISION_TO_DAMAGE = 'storeAddRevisionToDamage'
export const STORE_DELETE_DAMAGE = 'storeDeleteDamage'

const state = {
	damages: [],
}

const getters = {
	damages (state) {
		return state.damages
	},
}

const actions = {
	[FETCH_DAMAGES] (context, options) {
		return new Promise((resolve, reject) => {
			API.query('damages/' + options.inspection).then((response) => {
				context.commit(STORE_SET_DAMAGES, response.data)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[FETCH_ALL_DAMAGES] (context, options) {
		return new Promise((resolve, reject) => {
			API.query('objects/' + options.property + '/damages').then((response) => {
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[FETCH_DAMAGE] (context, options) {
		return new Promise((resolve, reject) => {
			API.query('damages/' + options.inspection + '/' + options.damage).then((response) => {
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[CREATE_DAMAGE] (context, options) {
		return new Promise((resolve, reject) => {
			API.post('damages/' + options.location, options.data).then((response) => {
				context.commit(STORE_ADD_DAMAGE, response.data)
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
	[UPDATE_DAMAGE] (context, options) {
		return new Promise((resolve, reject) => {
			API.update('damages/' + options.location, options.damage, options.changes).then((response) => {
				context.commit(STORE_UPDATE_DAMAGE, response.data)
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
	[DELETE_DAMAGE] (context, options) {
		return new Promise((resolve, reject) => {
			API.delete('damages/' + options.inspection + '/' + options.damage).then((response) => {
				context.commit(STORE_DELETE_DAMAGE, options.damage)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
}

const mutations = {
	[STORE_SET_DAMAGES] (state, damages) {
		state.damages = damages
	},
	[STORE_ADD_DAMAGE] (state, damage) {
		state.damages.push(damage)
	},
	[STORE_UPDATE_DAMAGE] (state, damage) {
		let damages = []

		state.damages.map((mapDamage) => {
			if (mapDamage.id === damage.id) {
				mapDamage = damage
			}

			damages.push(mapDamage)
		})

		state.damages = damages
	},
	[STORE_ADD_REVISION_TO_DAMAGE] (state, object) {
		let damages = []

		state.damages.map((damage) => {
			if( damage.id === object.damage ) {
				damage.revisions = [ object.revision ];
			}
		})

		state.damages = damages
	},
	[STORE_DELETE_DAMAGE] (state, damage) {
		state.damages.splice(state.damages.indexOf(damage), 1)
	},
}

export default { state, getters, actions, mutations }